import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { openInAppHelp } from '../utils/inAppHelpUtil';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContactUsLink = () => /*#__PURE__*/_jsx(Button, {
  onClick: () => openInAppHelp(),
  use: "link",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.exams.contactUs"
  })
});